import { tokens } from '../tokens';

export const card = {
  backgroundColor: tokens.colors.bgWhite,
  border: `1px solid ${tokens.colors.border}`,
  borderRadius: tokens.radius.md,
  boxShadow: tokens.shadow.sm,
};

export const panel = {
  backgroundColor: tokens.colors.bgSubtle,
  border: `1px solid ${tokens.colors.border}`,
  borderRadius: tokens.radius.md,
};

export const modalSurface = {
  backgroundColor: tokens.colors.bgWhite,
  borderRadius: tokens.radius.lg,
  boxShadow: tokens.shadow.lg,
};
